<div class="blogs-page">
  <section class="blogs-hero animate-fade-in-up" aria-label="Knowledge Base">
    <div class="blogs-hero__container">
      <div class="blogs-hero__head">
        <div class="blogs-hero__eyebrow">Knowledge Base</div>
        <h1 class="blogs-hero__title">
          Insights & <br class="blogs-hero__title-break" />Architecture.
        </h1>
        <p class="blogs-hero__copy">
          In-depth engineering analyses on AI integration, operational deflections, and the future of
          enterprise cloud management.
        </p>
      </div>

      @if (loading) {
        <div class="blogs-loading">Loading insights...</div>
      }

      @if (!loading && blogPosts.length > 0) {
        <div class="blogs-grid">
          @for (post of blogPosts; track post) {
            <a class="blog-card" [routerLink]="['/blog', post.id]"
              [attr.aria-label]="'Read ' + post.title" (click)="scrollToTop()">
              <div class="blog-card__media">
                <img [src]="post.imageUrl" [alt]="post.title" loading="lazy">
              </div>
              <div class="blog-card__meta">
                <span class="blog-card__category">{{ post.category }}</span>
                <span class="blog-card__read">{{ post.readTime }}</span>
              </div>
              <h2 class="blog-card__title">{{ post.title }}</h2>
              <p class="blog-card__excerpt">{{ post.excerpt }}</p>
              <div class="blog-card__foot">
                <span>{{ post.author }}</span>
                <span>{{ post.date }}</span>
              </div>
            </a>
          }
        </div>
      }

      @if (!loading && blogPosts.length === 0) {
        <div class="blogs-empty">
          No insights found.
        </div>
      }

      @if (!loading && totalCount > 0) {
        <div class="blogs-pagination">
          <div class="blogs-pagination__summary">
            Showing {{ startItem }} to {{ endItem }} of {{ totalCount }} results
          </div>
          @if (totalPages > 1) {
            <div class="blogs-pagination__controls">
              <button class="blogs-pagination__arrow" type="button" aria-label="Previous page"
                (click)="goToPreviousPage()" [disabled]="page === 1">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </button>
              @for (item of paginationItems; track item) {
                @if (item === '...') {
                  <span class="blogs-pagination__dots">...</span>
                }
                @if (item !== '...') {
                  <button class="blogs-pagination__page" type="button"
                    [class.blogs-pagination__page--active]="page === item" (click)="goToPage(+item)">
                    {{ item }}
                  </button>
                }
              }
              <button class="blogs-pagination__arrow" type="button" aria-label="Next page"
                (click)="goToNextPage()" [disabled]="page === totalPages">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </button>
            </div>
          }
        </div>
      }
    </div>
  </section>

  <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
  <div class="contact-section__container">
    <div class="contact-section__grid">
      <div>
        <div class="contact-section__eyebrow">Connect</div>
        <div class="contact-section__title">Discover the future of applied AI.</div>
        <div class="contact-section__copy">
          Connect with our delivery experts to audit your topology and map your enterprise integration
          roadmap.
        </div>
      </div>

      <div class="contact-card">
        <div class="contact-card__corner" aria-hidden="true"></div>
        <div class="contact-card__title">Direct Inquiry</div>

        <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <div>Request securely logged. Our architecture team will reach out within one business day.
          </div>
        </div>

        <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
          <div class="contact-form__field">
            <input type="text" formControlName="name" placeholder="Full Name" />
          </div>

          <div class="contact-form__row">
            <div class="contact-form__field">
              <input type="email" formControlName="email" placeholder="Corporate Email" />
            </div>
            <div class="contact-form__field">
              <input type="text" formControlName="company" placeholder="Organization" />
            </div>
          </div>

          <div class="contact-form__field">
            <textarea rows="3" formControlName="message"
            placeholder="Brief context of operational challenges..."></textarea>
          </div>

          <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
            class="contact-form__submit">
            <span *ngIf="!isSubmitting">Transmit Request</span>
            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              Encrypting...
            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</section> -->
</div>
